import { useCallback, useState } from 'react';

export type ModalResult = {
  open(): void;
  close(): void;
  isOpen: boolean;
};

const useModal = (): ModalResult => {
  const [isOpen, setOpen] = useState(false);

  const open = useCallback(() => {
    setOpen(true);
  }, []);

  const close = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    open,
    close,
    isOpen
  };
};

export default useModal;
